import { render, staticRenderFns } from "./TabBusinessInteligence.vue?vue&type=template&id=37836b71&scoped=true"
import script from "./TabBusinessInteligence.vue?vue&type=script&lang=js"
export * from "./TabBusinessInteligence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37836b71",
  null
  
)

export default component.exports